"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const constants_1 = require("../constants");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
class TraceUrl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: constants_1.ProgressState.Loading
        };
    }
    render() {
        return React.createElement("div", { className: "text-center mt-2" }, React.createElement(LoadingSpinner_1.default, null));
    }
    componentDidMount() {
        let code = this.props.params.token;
        api_1.doGet(api_1.API.v1.TRACE_URL.GET(code)).then(res => {
            window.location.href = res.data.link;
        }).catch(error => {
            this.setState({ status: constants_1.ProgressState.Failed });
            api_1.handleError(error);
        });
    }
}
exports.default = TraceUrl;


//////////////////
// WEBPACK FOOTER
// ./client/src/layout/TraceUrl.tsx
// module id = 1361
// module chunks = 1 2